import React, { Fragment } from "react";
import externalLink from "../../../assets/images/external-link.png";

const FabricLibraryList = props => {
    let fabricpage = data2 => {
        let action = (props.rights.web.edit && "edit") || (props.rights.web.view && "view"),
            k = props.processType;
        let fabricsearch = "?" + new URLSearchParams({
            action: action,
            _id: data2._id,
            // hash: `seleted${data2.number.split("-").join("")}`
        }).toString()
        window.open(`/developmentFabric${fabricsearch}`, "_blank")
    }
    return (
        <Fragment>

            <table id="fabTable" >

                <tr>
                    <div className="row">
                        {props.list !== undefined &&
                            Array.isArray(props.list) &&
                            props.list.length > 0 &&
                            props.list.map(listValue => {
                                return (
                                    <Fragment>
                                        <div className=" col-md-3 ">

                                            <td>
                                                <span onClick={() => fabricpage(listValue)}>
                                                    {listValue.fabricNumber}
                                                </span>
                                            </td>
                                            <div className="row ">
                                                <div className="col-md-auto ">
                                                    <td className="p-1">
                                                        <img
                                                            className="fabric-library-report-img"
                                                            onClick={() =>
                                                                props.modalData(listValue.fabricImage)

                                                            }
                                                            src={listValue.fabricImage}
                                                        />
                                                    </td>

                                                </div>
                                                <div className="col-md-3">
                                                    <div>
                                                        <td className="p-0 "><b>Name-Type</b> : {listValue.imageType}</td>
                                                    </div>
                                                    <div>
                                                        <td className="p-0"><b>Quality</b> : {listValue.quality}</td>
                                                    </div>
                                                    <div>
                                                        <td className="p-0"><b>Composition</b> : {listValue.composition || ""}</td>
                                                    </div>
                                                    <div>
                                                        <td className="p-0"><b>Requirement</b> : {listValue.requirement || ""}</td>
                                                    </div>
                                                    <div>
                                                        <td className="p-0">{listValue.countConstruction}</td>
                                                    </div>
                                                    {/* <div>
                                                        <td className=""> Date : {listValue.createdAt}</td>
                                                    </div> */}

                                                </div>
                                            </div>
                                        </div>



                                    </Fragment>
                                )
                            })}
                    </div>
                </tr>

            </table>
        </Fragment>
    );
};

export default FabricLibraryList


// WEBPACK FOOTER //
// ./src/components/Report/reports/fabricLibraryList.js